<template>
  <div class="flex-col justify-start relative page">
    <div class="flex-col justify-start items-center">
      <img class="image_1"
        src="https://immortalcq.oss-cn-chengdu.aliyuncs.com/static/imagesNew/mourning_backgroud.jpg" />
    </div>
    <div class="logom" @click="back">
      <img src="@/assets/logo.png" alt="">
    </div>

    <!-- 烟雾 -->
    <img class="smokebg" src="https://immortalcq.oss-cn-chengdu.aliyuncs.com/static/imagesNew/smoke_backgroud.jpg"
      alt="">

    <!-- 消息滚动面板 -->
    <div class="content">
      <div class="mb">
        <div class="mbTop">
          <div class="wzm">
            <img class="icon" src="@/assets/mourningimges/img5.png" alt="">
            <div>留言: {{ total }}条</div>
          </div>
        </div>

        <vue-seamless-scroll :data='list' :class-option="optionHover" class="scroll" @ScrollEnd="ScrollEnd"
          v-if="list.length > 0">
          <div class="list" v-for="(item, index) in list" :key="index">
            <div class="wz" v-if="item.type == 1">
              <div style="display: flex;align-items: center;">
                <div>
                  {{ item.nickname }}<span class="span">送了一朵{{ item.oblation_name }}</span>
                </div>
                <img :src="item.image" alt="">
              </div>
            </div>

            <div class="wz" v-if="item.type == 2">
              <div style="display: flex;align-items: center;">
                <div>
                  {{ item.nickname }}<span class="span">上了一炷{{ item.oblation_name }}</span>
                </div>
                <img :src="item.image" alt="">
              </div>
            </div>

            <div class="wz" v-if="item.type == 3">
              <div style="display: flex;align-items: center;">
                <div>
                  {{ item.nickname }}<span class="span">说{{ item.content }}</span>
                </div>
              </div>
            </div>

          </div>
        </vue-seamless-scroll>
      </div>
    </div>


    <!-- 人物面板 -->
    <div class="peoplem relative">
      <img class="avatar" :src="image" alt="">
      <div class="sweetm">
        <img class="icon" src="@/assets/mourningimges/img6.png" alt="">
        <div class="name">{{ name }}</div>
        <img class="icon" src="@/assets/mourningimges/img6.png" alt="">
      </div>
    </div>


    <!-- 香炉 -->
    <img class="censer" src="https://immortalcq.oss-cn-chengdu.aliyuncs.com/hall/wood/graphic/default.gif" alt="">
  </div>
</template>
<script>
import { detileGet, getList, howlist } from "@/api/go";

export default {
  components: {},
  beforeRouteEnter(to, from, next) {
    let s = to.query.s;
    if (s) {
      if (s == 1) {
        next({
          name: "index",
          query: to.query
        });
      } else if (s == 2) {
        next();
      } else if (s == 3) {
        next({
          name: "VideoAnimation",
          query: to.query
        });
      }
    } else {
      next();
    }
  },
  data() {
    return {
      list: [],//请求的数据
      id: null,
      name: '',
      image: '',
      page: 1,
      sfxyy: true,//下一页是否有数据
      total: 0,
      timer: null, // 用来保存定时器的 ID
    }
  },
  mounted() {
    this.id = this.$route.query.id;
    setTimeout(() => {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      this.$router.replace({
        name: "index",
        query: {
          id: this.id
        }
      });
    }, 1 * 60 * 1000)

    this.detileData()
    this.getList()


    // this.timer = setInterval(() => {
    //   this.howlist()
    // }, 2000);
  },
  onUnload() {
    // 页面卸载时清除定时器
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  computed: {
    optionHover() {
      return {
        step: 1, // 数值越大速度滚动越快
        limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1 
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      }
    }
  },
  watch: {

  },
  methods: {
    back() {
      this.$router.replace({
        name: "index",
        query: {
          id: this.id
        }
      });
    },
    ScrollEnd() {
      this.page++
      this.getList()
    },
    // 获取灵堂详情
    detileData() {
      detileGet({
        userId: Number(this.id)
      }).then(res => {
        this.name = res.name
        this.image = res.image
      }).catch(err => {

      });
    },
    // 消息列表
    getList() {
      if (!this.sfxyy) {
        return
      }
      getList({
        userId: Number(this.id),
        page: this.page,
        limit: 20
      }).then(res => {
        if (res.data.length < 20) {
          this.sfxyy = false
        } else {
          this.sfxyy = true
        }
        this.total = res.total
        this.list = this.list.concat(res.data)
      }).catch(err => {

      });
    },
    // 谁来了
    howlist() {
      howlist({
        userId: Number(this.id),
        page: 1,
        limit: 20,
      }).then(res => {
        console.log(res)
        // let array1 = this.list
        // let array2 = res.data.data

        // // 提取 array2 中 id 不在 array1 中的对象
        // let uniqueInArray2 = array2.filter(item2 =>
        // 	!array1.some(item1 => item1.id === item2.id)
        // );

        // for (let i = 0; i < uniqueInArray2.length; i++) {
        // 	console.log(uniqueInArray2[i])
        // 	array1.push(uniqueInArray2[i]);
        // }
        // this.list = array1
        // // 如果是自己发布的
        // if (ty == 1) {
        // 	this.$nextTick(function() {
        // 		// 滚动到底
        // 		this.scrollToView = 'msg' + array1[array1.length - 1].id
        // 	});
        // }
      }).catch(err => {

      });
    }
  }
};
</script>
<style lang="less" scoped>
.page {
  width: 100%;
  height: 100%;

  .image_1 {
    width: 100vw;
    height: 100vh;
  }

  .logom {
    position: absolute;
    left: 92px;
    top: 70px;
    cursor: pointer;

    img {
      height: 40px;
    }
  }

  .smokebg {
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    height: 50%;
    width: 100%;
  }


  .content {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 40%;
    height: 60%;
    padding: 40px;

    .mb {
      height: 100%;

      .mbTop {
        font-size: 26px;
        padding: 5px 10px;
        color: #FF511B;
        background: rgba(255, 255, 255, 0.4);
        border-radius: 50px;
        display: inline-block;

        .wzm {
          display: flex;
          align-items: center;

          .icon {
            width: 30px;
            height: 35px;
            margin-right: 10px;
          }
        }
      }

      /* Webkit 内核浏览器（如 Chrome, Safari） */
      .scroll::-webkit-scrollbar {
        display: none;
        /* 隐藏滚动条 */
      }

      .scroll {
        height: 90%;
        margin-top: 35px;
        overflow-y: auto;
        scrollbar-width: none;
        -ms-overflow-style: none;
        .list {
          margin-bottom: 35px;
          width: auto !important;

          .wz {
            font-size: 26px;
            color: #FF511B;
            background: rgba(255, 255, 255, 0.4);
            border-radius: 50px;
            padding: 10px 15px;
            display: inline-block;

            .span {
              color: #000;
              padding-left: 5px;
            }

            img {
              width: 30px;
              margin-left: 5px;
            }
          }
        }
      }
    }
  }


  .peoplem {
    width: 490px;
    height: 542px;
    position: absolute;
    top: 22px;
    left: 50%;
    transform: translate(-50%);
    display: flex;
    justify-content: center;
    align-items: center;

    .avatar {
      width: 400px;
    }

    .sweetm {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 39px;
      height: 170px;
      display: flex;
      justify-content: space-between;

      .icon {
        width: 30%;
        // height: 169px;
      }

      .name {
        padding: 0 20px;
        height: 60px;
        line-height: 60px;
        background: rgba(255, 255, 255, 0.4);
        font-size: 26px;
        color: #000;
        font-weight: bold;
        border-radius: 50px;
        margin-top: 100px;
      }
    }
  }

  .censer {
    width: 30%;
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translate(-50%);
  }
}
</style>